"use strict";

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconChevronsRight = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _core = require("@emotion/core");

var IconChevronsRight = function IconChevronsRight(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, _core.jsx)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), (0, _core.jsx)("path", {
    fill: color,
    d: "M17.138 12.195l3.333 3.334c.26.26.26.682 0 .942l-3.333 3.334a.667.667 0 11-.943-.943L19.057 16l-2.862-2.862a.667.667 0 11.943-.943zm-4.667 0l3.334 3.334c.26.26.26.682 0 .942l-3.334 3.334a.667.667 0 11-.942-.943L14.39 16l-2.861-2.862a.667.667 0 11.942-.943z"
  }));
};

exports.IconChevronsRight = IconChevronsRight;
IconChevronsRight.displayname = 'IconChevronsRight';
process.env.NODE_ENV !== "production" ? IconChevronsRight.propTypes = {
  color: _propTypes.string
} : void 0;
IconChevronsRight.defaultProps = {
  color: '#566'
};